var map = {
	"./articles.de-CH.json": 1407,
	"./articles.de-DE.json": 1408,
	"./articles.en-CA.json": 1409,
	"./articles.en-GB.json": 1410,
	"./articles.en-IN.json": 1411,
	"./articles.en-ME.json": 1412,
	"./articles.en-US.json": 1413,
	"./articles.es-EM.json": 1414,
	"./articles.es-ES.json": 1415,
	"./articles.fr-BE.json": 1416,
	"./articles.fr-CA.json": 1417,
	"./articles.fr-CH.json": 1418,
	"./articles.nl-BE.json": 1419,
	"./articles.nl-NL.json": 1420,
	"./articles.pl-PL.json": 1421,
	"./articles.pt-BR.json": 1422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1406;